import React, { useState } from "react";

const DataContext = React.createContext();

function DataProvider(props) {
  const [sample_data, SetSampleData] = useState("");
  const [app_data, SetAppData] = useState({
    brand_id: "",
    outlet_id: "",
    user_data: {},
    active_account_data: {},
  });

  return (
    <DataContext.Provider
      value={{
        app_data,
        SetAppData,
      }}
    >
      {props.children}
    </DataContext.Provider>
  );
}
export { DataProvider };

// export const DataProvider = DataContext.Provider;
export const DataConsumer = DataContext.Consumer;

export default DataContext;
